import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 11H16V13H8V11ZM20 8V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H14C14.27 2 14.52 2.11 14.71 2.29L19.71 7.29C19.9 7.48 20 7.73 20 8ZM15 7H16.59L15 5.41V7ZM18 20V9H13V4H6V20H18ZM8 17H16V15H8V17Z" fill={ fill || 'currentColor' } />
    </svg>
);
